import HttpService from 'services/HttpService';
import { IListResponse, IRequestReturnType } from 'interfaces/common';
import {
  IAppointment,
  IAppointmentForm,
  IPharmacyService,
  IServicesQuery,
  IUserSignature,
  IUserSignaturePost,
} from 'modules/forms/interfaces/form.interfaces';

export function getFormAppointment<L = IAppointment>(uuid: string): Promise<IRequestReturnType<L>> {
  return HttpService.request({ method: 'get', url: `/appointments/${uuid}/widget` });
}

export function postAppointmentForm<L = IAppointmentForm>(
  data: Partial<IAppointmentForm>,
  photos?: File[],
): Promise<IRequestReturnType<L>> {
  const formData = new FormData();
  const dto = new Blob([JSON.stringify(data)], {
    type: 'application/json',
  });
  formData.append('dto', dto);
  if (photos?.length) {
    photos.forEach(file => {
      formData.append('attachments', file);
    });
  }
  return HttpService.request({ method: 'post', url: '/appointmentForms', data: formData });
}

export function getServices<L = IListResponse<IPharmacyService>>(
  query: IServicesQuery,
): Promise<IRequestReturnType<L>> {
  return HttpService.request<L>({ method: 'get', url: '/pharmacyServices', params: query });
}

export function getUserSignatures<L = IUserSignature[]>(): Promise<IRequestReturnType<L>> {
  return HttpService.request<L>({ method: 'get', url: '/users/self/signatures' });
}

export function createUserSignature<L = IUserSignature>(
  data: IUserSignaturePost,
): Promise<IRequestReturnType<L>> {
  const formData = new FormData();

  formData.append('signatureName', data.signatureName);
  formData.append('signatureFile', data.signatureFile);

  return HttpService.request<L>({
    method: 'post',
    url: '/users/self/signatures',
    data: formData,
    headers: { 'content-type': 'multipart-formdata' },
  });
}
